import { IAuthorizedInstallerRequest } from '@authorizedInstaller/types/authorizedInstallers';
import { createContext, useContext } from 'react';

enum AUTHORIZED_INSTALLER_TABS {
    NEW_FORMS = 0,
    OLD_FORMS = 1,
}

const AuthorizedInstallersDashboardContext = createContext<
    | {
          tab: AUTHORIZED_INSTALLER_TABS;
          installerRequest: IAuthorizedInstallerRequest | null;
      }
    | undefined
>(undefined);

const useAuthorizedInstallersDashboardContext = () => {
    const context = useContext(AuthorizedInstallersDashboardContext);
    if (!context) throw new Error('useAuthorizedInstallersDashboardContext must be used within a provider');
    return context;
};

export { AUTHORIZED_INSTALLER_TABS, AuthorizedInstallersDashboardContext, useAuthorizedInstallersDashboardContext };
